import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');
var report = require('../generics/report_head');

class MounthlyProductivity extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
        this.onPrint = this.onPrint.bind(this);

		this.setTable = this.setTable.bind(this);

		this.state = {
			health_facilities_id:"",
			start_date 	: "",
			end_date 	: "",
			list:[],

			//test datatable to export
			columns:[
                {title:'Proceso'},
                {title:'Medición'}		
			],
			filename:"Informe Mensual de Productividad de los Centros de Colecta",

			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
        
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		//this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

    onPrint(type){
        var obj = {
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            health_facilities_id: this.state.health_facilities_id,
        };
        if(type === 'excel'){
            this.props.printExcelReport(this.state.filename, 'productivity_report', obj);
        }else{
            this.props.printPdfIMSSReports('productivity_report', obj);
        }
    }

	setTable(){
		this.$el = $(this.el);

        var obj = {
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            health_facilities_id: this.state.health_facilities_id,
        };

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
                
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	action: (e, dt, node, config)=>{
                        this.props.printExcelReport(this.state.filename, 'productivity_report', obj);
                    }
            	},
                {
                    text:'PDF',
                    action: (e, dt, node, config)=>{
                        this.props.printPdfIMSSReports('productivity_report', obj);
                    }
                }
            ],
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
			},
			paging:false,
            ordering:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});
		

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					start_date: this.state.start_date,
					end_date: this.state.end_date,
                    health_facilities_id: this.state.health_facilities_id
				}
				
				fetch(Config.default.apiGateway.URL+'reports_imss/productivity_report',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();

					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var columns = [
                            {title:'Proceso', width:'160px'},
                            {title:'Medición', width:'160px'}		
                    ];

                        var list = [];
                        var obj = [];

                        response.convoke_places.forEach((convoke)=>
                            columns.push({title:convoke.code, id:convoke.id, width:'80px'})
                        );

                        columns.push({title:'Total', width:'80px'});

                        obj = [{value:'Recepción de unidades'}, {value:'Unidades recibidas'}];
                        columns.forEach((col)=>{
                            if(col.id !== undefined){
                                var index =  response.totals.findIndex(item => item.convoke_place_id === col.id);

                                if(index !== -1){
                                    obj.push({value: response.totals[index].total});
                                }else{
                                    obj.push({value:''});
                                }
                            }                                    
                        });

                        obj.push({value:response.total});
                        list.push(obj);

                        obj = [{value:'TOTAL DE UNIDADES'}, {value:'UNIDADES EFECTIVAS'}];
                        columns.forEach((col)=>{
                            if(col.id !== undefined){
                                var index =  response.effectives.findIndex(item => item.convoke_place_id === col.id);

                                if(index !== -1){
                                    obj.push({value: response.effectives[index].total});
                                }else{
                                    obj.push({value:''});
                                }
                            }                                    
                        });

                        obj.push({value:response.total_effectives});
                        list.push(obj);

                        response.discard_categories.forEach((cat)=>{
                            cat.discard_reasons.forEach((reason, i)=>{
                                obj = [];
                                if(i === 0){
                                    obj.push({
                                        value:cat.name,
                                        rowspan:cat.discard_reasons.length+1
                                    });
                                }

                                obj.push({value: reason.name})
                                
                                columns.forEach((col)=>{
                                    if(col.id !== undefined){
                                        var index =  reason.details.findIndex(item => item.convoke_place_id === col.id);

                                        if(index !== -1){
                                            obj.push({value: reason.details[index].total});
                                        }else{
                                            obj.push({value:''});
                                        }
                                    }                                    
                                });

                                obj.push({value:reason.total});

                                list.push(obj);
                            })

							obj = [{
                                value:' Total Bajas '
                            }];
                            
                            columns.forEach((col)=>{
                                if(col.id !== undefined){
                                    var index =  cat.totals.findIndex(item => item.convoke_place_id === col.id);

                                    if(index !== -1){
                                        obj.push({value: cat.totals[index].total});
                                    }else{
                                        obj.push({value:''});
                                    }
                                }
                            });

                            obj.push({value:cat.total});

                            list.push(obj);
                        })

                        

                        response.discard_categories.forEach((cat)=>{
                            obj = [{
                                value:'% BAJAS POR '+cat.code,
                                colspan:2
                            }];
                            
                            columns.forEach((col)=>{
                                if(col.id !== undefined){
                                    var index =  cat.percentages.findIndex(item => item.convoke_place_id === col.id);

                                    if(index !== -1){
                                        obj.push({value: cat.percentages[index].percentage+'%'});
                                    }else{
                                        obj.push({value:''});
                                    }
                                }
                            });

                            obj.push({value:cat.percentage+'%'});

                            list.push(obj);
                        })

                        setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							//this.$el.DataTable().destroy();
							//this.$el.empty();

                            this.setState({
                                columns:columns,
                                list:list
                            });
                            
						}, 1000);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							//this.setTable();
						}, 1500);

                        

					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;
		const { selectedOption } = this.state;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
                        {session+' -> '}
                        {t('sidebar.nav.reports.MAIN')+' -> '}
                        {'IMSS -> '}
                        {this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_productivity_report"}  />

				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
                                <div className="form-group">
                                    <span className="span-min">Fecha Desde</span>
                                    <input type="date" className="form-control hour-input" name="start_date" id="start_date"
                                        value={this.state.start_date} onChange={this.handleChange} required />
                                </div>
                                <div className="form-group">
                                    <span className="span-min">Fecha Hasta</span>
                                    <input type="date" className="form-control hour-input" name="end_date" id="end_date"
                                        value={this.state.end_date} onChange={this.handleChange} required />
                                </div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>

								</div>

                                <div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.list.length === 0} onClick={(e) => this.onPrint('excel')} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.list.length === 0} onClick={(e) => this.onPrint('pdf')}>PDF</button>
                                </div>

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className=" table expenses-discards" id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
                                            <thead>
                                                <tr>
                                                    {this.state.columns.map((col, i)=>
                                                        <th key={i} 
                                                            style={{width:col.width}}>
                                                                {col.title}
                                                        </th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.list.map((list, i)=>
                                                    <tr key={i}>
                                                        {list.map((cell, j)=>
                                                            cell.colspan ?
                                                                <td key={j} colSpan={cell.colspan}>{cell.value}</td>
                                                            : cell.rowspan ?
                                                                <td key={j} rowSpan={cell.rowspan}>{cell.value}</td>
                                                            :
                                                                <td key={j}>{cell.value}</td>
                                                            
                                                        )}                                                        
                                                    </tr>
                                                )}
                                            </tbody>
										</table>
									</div>

								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (MounthlyProductivity);